import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, NgZone, OnChanges, OnDestroy, Output, QueryList, SimpleChanges, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { IWindowService } from "angular";
import { Observable, Observer, Subscription } from "rxjs";
import { debounceTime } from 'rxjs/operators';
import type { DashboardModuleResponsiveInstance } from 'src/shared/models/module-info.model';
import { BaseGroupType } from 'src/AngularJS/Models/group-type.model';
import { GroupSelectorDTO } from 'src/AngularJS/Reusables/group-selector.models';
import { DashboardService } from 'src/app/dashboard/dashboard.service';
import { AttributeCategoryModel, AttributeSelectorModel, AttributeType, SelectedCategoryModel } from 'src/shared/models/attribute-selector.models';
import { IModuleCustomSettingSection, ModuleCustomSettingSectionType } from 'src/shared/models/module-custom-settings-section.model';
import type { ModuleManager } from 'src/shared/models/module-manager';
import { IModuleManagerSettingsComponent, ModuleManagerDateRangeInfo, ModuleManagerGenericSettingsControls, ModuleManagerModuleSettings, ModuleSettingsAppliedModel, ModuleSettingsView, SlideoutSettingsOptions, TimeInterval } from 'src/shared/models/module-manager/module-manager-settings.models';
import SlideoutSettingsManager from 'src/shared/models/slideout-settings-manager';
import { ClearViewUtils } from 'src/shared/utils';
import { AttributeSelectorService } from '../attribute-selector/attribute-selector.service';
import { DateRangeSelectorService } from '../date-range-selector/date-range-selector.service';
import { CVApiService } from '../services/cv-api.service';
import { CVLocalizationService } from '../services/cv-localization.service';
import { MetricSelectorService } from '../../reusables/metric-selector/metric-selector.service'
import { MetricSelectorComponent } from '../metric-selector/metric-selector.component';
import { GeneralWallboardSettings, ModuleType, WallboardModule, WallboardSlideSettings } from '../../wallboards/wallboards.model';


@Component({
    selector: 'cv-settings-slideout',
    templateUrl: './settings-slideout.component.html',
    styleUrls: ['./settings-slideout.component.scss'],
})
export class SettingsSlideoutComponent implements OnChanges, OnDestroy, AfterViewInit, IModuleManagerSettingsComponent  {
    @Input() settingsLoading: boolean;
    @Input() moduleManager?: ModuleManager;

    @Output() settingsApplied = new EventEmitter<ModuleSettingsAppliedModel>();
    @Output() changeSlideoutTitle = new EventEmitter<{ title: string, ShowTitle: boolean }>();
    @Output() settingsCancelled = new EventEmitter<void>();
    @Output() settingsViewChanged = new EventEmitter<IModuleManagerSettingsComponent>();
    @Output() onWallboardGeneralSettingChanged = new EventEmitter<GeneralWallboardSettings>();

    // ViewChildren for Custom Settings placements
    @ViewChild('beforeAll', { read: ViewContainerRef }) vcrBeforeAll: ViewContainerRef;
    @ViewChild('afterAll', { read: ViewContainerRef }) vcrAfterAll: ViewContainerRef;
    @ViewChild('insideDate', { read: ViewContainerRef }) vcrInsideDate: ViewContainerRef;
    @ViewChild('afterDate', { read: ViewContainerRef }) vcrAfterDate: ViewContainerRef;
    @ViewChild('insideEmp', { read: ViewContainerRef }) vcrInsideEmp: ViewContainerRef;
    @ViewChild('afterEmp', { read: ViewContainerRef }) vcrAfterEmp: ViewContainerRef;
    @ViewChild('insideRec', { read: ViewContainerRef }) vcrInsideRec: ViewContainerRef;
    @ViewChild('afterRec', { read: ViewContainerRef }) vcrAfterRec: ViewContainerRef;
    @ViewChild('insideAtt', { read: ViewContainerRef }) vcrInsideAtt: ViewContainerRef;
    @ViewChild('afterAtt', { read: ViewContainerRef }) vcrAfterAtt: ViewContainerRef;
    @ViewChild('insideMetric', { read: ViewContainerRef }) vcrInsideMetric: ViewContainerRef;
    @ViewChild('afterMetric', { read: ViewContainerRef }) vcrAfterMetric: ViewContainerRef;

    @ViewChildren('metricSelectorContainer', {read: ElementRef}) metricSelectorContainerQl: QueryList<ElementRef<HTMLDivElement>>;

    @Input() private module?: DashboardModuleResponsiveInstance;
    @Input() private includeDateSelector?: boolean;
    @Input() private includeDaysOfWeek?: boolean;
    @Input() private includeTimeSelector?: boolean;
    @Input() private includeIntervalSelector?: boolean;
    @Input() private includeEmpGroupSelector?: boolean;
    @Input() private includeRecGroupSelector?: boolean;
    @Input() private includeAttributesSelector?: boolean;
    @Input() private includeViewBy?: boolean;
    @Input() private enableMultiGroupSelect?: boolean;
    @Input() private includeMetricSelector?: boolean;
    @Input() private includeSettingSlideDuration?: boolean;
    @Input() public includeSettingColumnSort?: boolean;
    @Input() private pageName?: string;
    @Input() public isWallboard?: boolean = false;
    @Input() private wallboardId?: number;
    @Input() public wallboardCreatorId?: number;
    @Input() public availableWallboardSettings?: WallboardModule;
    @Input() public selectedSlideSettings?: WallboardSlideSettings;
    @Input() public SettingsModuleType?: ModuleType;

    initialized = false;
    options: SlideoutSettingsOptions = new SlideoutSettingsOptions();
    $element: JQuery<HTMLElement>;
    genericSettingsLoading: boolean;
    genericSettingsLoaded: boolean;
    hasMetricSelector: boolean;
    hasDateSelector: boolean;
    hasEmpSelector: boolean;
    hasRecSelector: boolean;
    hasAttSelector: boolean;
    hasIntervalSelector: boolean;
    settingsManager: SlideoutSettingsManager;
    allText: string;
    prevSlideName: string = '';

    inDataCatView = false;
    inUserCatView = false;
    isEditingName = false;

    dateExpanded = false;
    empExpanded = false;
    recExpanded = false;
    metricsExpanded = false;
    attExpanded = false;
    wallboardGeneralExpanded = false;

    initializedLevelName: string

    private metricSelectorContainerEl: ElementRef<HTMLDivElement>;
    private metricSelectorHtml = '';

    private _subscriptions: Subscription[] = [];

    constructor(
        private elementRef: ElementRef<HTMLElement>,
        @Inject('$window') private $window: IWindowService,
        private cvApiService: CVApiService,
        private cvLocalizationService: CVLocalizationService,
        private attributeSelectorService: AttributeSelectorService,
        private dateRangeSelectorService: DateRangeSelectorService,
        private cd: ChangeDetectorRef,
        private ngZone: NgZone,
        public dashboardService: DashboardService,
        public metricSelectorService: MetricSelectorService,
    ) {
        this.$element = $(elementRef.nativeElement);
    }

    initialize() {
        this.settingsManager = new SlideoutSettingsManager(this.attributeSelectorService, this.module);
        this._subscriptions.push(this.settingsManager.onPlaceCustomSettings.subscribe(
            component => this.placeCustomSettingsSection(component)
            
        ));

        if (this.isWallboard)
            this.setWallboardSettings();
        this.cvLocalizationService.GetSection("Common");
        this.cvLocalizationService.GetSection("Wallboard_Management_Messages");
        this.cvLocalizationService.GetSection("Slideout_Settings");
        this.allText = this.cvLocalizationService.getCachedText('Common', 'All', 'All');

        // use an event to update the @ViewChild because ng-metadata doesn't seem to be working correctly.
        // will look into trying again in new Angular
        this.settingsViewChanged.emit(this);

        // hook up metric selector reload here until a metric selector component is created
        this._subscriptions.push(this.settingsManager.onSelectedRecGroupsChanged.subscribe(() => this.reloadMetrics()));
        //this._subscriptions.push(this.settingsManager.onSelectedGroupViewByChanged.subscribe(() => this.reloadMetrics())); // Not used until metric selector accounts for selected level

        // handle jQuery event for metric selector because Angular can only handle native events
        $(document).on('event_SelectedMetricsChanged', this.onSelectedMetricsChangedHandler);

        this.initialized = true;

        if (this.moduleManager) {
            // update the settings manager for the module after Angular has a chance to read the initialized value and generate the DOM
            setTimeout(() => this.moduleManager.slideoutSettingsManager.next(this.settingsManager));
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        // if module is set, load options from it first
        if (changes.module?.currentValue)
            this.options = SlideoutSettingsOptions.fromModuleDto(changes.module.currentValue);

        // load any other set options as overrides to defaults/module options
        if (changes.includeDateSelector?.currentValue != null)
            this.options.includeDateSelector = changes.includeDateSelector.currentValue;
        if (changes.includeDaysOfWeek?.currentValue != null)
            this.options.includeDaysOfWeek = changes.includeDaysOfWeek.currentValue;
        if (changes.includeTimeSelector?.currentValue != null)
            this.options.includeTimeSelector = changes.includeTimeSelector.currentValue;
        if (changes.includeIntervalSelector?.currentValue != null)
            this.options.includeIntervalSelector = changes.includeIntervalSelector.currentValue;
        if (changes.includeEmpGroupSelector?.currentValue != null)
            this.options.includeEmpGroupSelector = changes.includeEmpGroupSelector.currentValue;
        if (changes.includeRecGroupSelector?.currentValue != null)
            this.options.includeRecGroupSelector = changes.includeRecGroupSelector.currentValue;
        if (changes.includeViewBy?.currentValue != null)
            this.options.includeViewBy = changes.includeViewBy.currentValue;
        if (changes.enableMultiGroupSelect?.currentValue != null)
            this.options.enableMultiGroupSelect = changes.enableMultiGroupSelect.currentValue;
        if (changes.includeMetricSelector?.currentValue != null)
            this.options.includeMetricSelector = changes.includeMetricSelector.currentValue;
        if (changes.includeAttributesSelector?.currentValue != null)
            this.options.includeAttributesSelector = changes.includeAttributesSelector.currentValue;
        if (changes.includeSoloUserAttributesSelector?.currentValue != null)
            this.options.includeSoloUserAttributesSelector = changes.includeSoloUserAttributesSelector.currentValue;

        if (changes.moduleManager?.isFirstChange() || changes.pageName?.isFirstChange()) {
            this.initialize();
        }

        this.setInitialLevelName()
    }

    async setInitialLevelName() {
    	if (!this.moduleManager?.moduleSettings) return;
        if (this.moduleManager) {
            this.initializedLevelName = this.moduleManager.moduleSettings.selectedGroupLevelName;
            this.settingsManager.selectedLevelName = this.moduleManager.moduleSettings.selectedGroupLevelName;
            this.settingsManager.selectedToggle = this.moduleManager.moduleSettings.selectedGroupType;
        }
    }

    ngAfterViewInit() {
        this.initializeMetricSelectorContainer(this.metricSelectorContainerQl);
        this.metricSelectorContainerQl.changes.subscribe((next: QueryList<ElementRef<HTMLDivElement>>) => {
            this.initializeMetricSelectorContainer(next);
        });
    }

    ngOnDestroy() {
        this._subscriptions.forEach(sub => sub.unsubscribe());
        $(document).off('event_SelectedMetricsChanged', this.onSelectedMetricsChangedHandler);
    }

    get stateKey() {
        const stateKey = this.pageName ?? this.moduleManager?.getModuleKey();
        if (stateKey == null)
            throw Error("stateKey could not be determined. Neither moduleManager or pageName is set.");
        return stateKey;
    }

    get selectedLevelName() {
        if (this.settingsManager.showInitialLevelName)
            return this.initializedLevelName

        return this.settingsManager.selectedLevelName;
    }

    initializeMetricSelectorContainer(container: QueryList<ElementRef<HTMLDivElement>>) {
        this.metricSelectorContainerEl = container.first;
        if (this.metricSelectorContainerEl && this.metricSelectorHtml)
            this.metricSelectorContainerEl.nativeElement.innerHTML = this.metricSelectorHtml;
    }

    /**
     * Handles metric change events fired from the metric selector
     *
     * @param e The event fired from the metric selector.
     */
    onSelectedMetricsChanged(e) {
        const temp = this.isWallboard ? "" : "_temp"; //wallboards doesn't use _temp state
        if (!e.result && e.pageName === `${this.stateKey}${temp}`) {
            this.ngZone.run(() => {
                this.settingsManager.selectedMetrics = e.selectedMetrics.map(metricId => ({
                    Id: metricId,
                    Abbreviation: e.metricNames[metricId].trim(),
                    Name: e.metricFullNames[metricId],
                    ConversionType: parseInt(e.mCT[metricId], 10), 
                    CustomName: this.settingsManager.selectedMetrics.find(m => m.CustomName && m.Id == metricId)?.CustomName
                }));

                this.settingsManager.updateSelectedMetricsText();
            });
        }
    }

    placeCustomSettingsSection(component: IModuleCustomSettingSection) {
        if (component.type !== ModuleCustomSettingSectionType.Slideout)
            return;

        const $customSection = component.getNativeElement();
        let targetPlaceholder: ViewContainerRef;

        // determine which ViewContainerRef to place the component after
        if (component.after != null) {
            switch (component.after) {
                case 'date': targetPlaceholder = this.vcrAfterDate; break;
                case 'emp': targetPlaceholder = this.vcrAfterEmp; break;
                case 'rec': targetPlaceholder = this.vcrAfterRec; break;
                case 'att': targetPlaceholder = this.vcrAfterAtt; break;
                case 'metric': targetPlaceholder = this.vcrAfterMetric; break;
                case 'all': targetPlaceholder = this.vcrAfterAll; break;
                default: targetPlaceholder = this.vcrBeforeAll; break;
            }
        } else if (component.inside != null) {
            switch (component.inside) {
                case 'date': targetPlaceholder = this.vcrInsideDate; break;
                case 'emp': targetPlaceholder = this.vcrInsideEmp; break;
                case 'rec': targetPlaceholder = this.vcrInsideRec; break;
                case 'att': targetPlaceholder = this.vcrInsideAtt; break;
                case 'metric': targetPlaceholder = this.vcrInsideMetric; break;
                default: targetPlaceholder = this.vcrBeforeAll; break;
            }
        } else {
            targetPlaceholder = this.vcrBeforeAll;
        }

        // place the custom section inside of the target container
        const $placeholderElement: Node = targetPlaceholder.element.nativeElement;
        $placeholderElement.parentNode.insertBefore($customSection, $placeholderElement);
    }

    setGenericSettingsControlSettings(controlSettings: ModuleManagerModuleSettings) {
        this.settingsManager.setSettings(controlSettings);
        this.cd.detectChanges();
    }

    setGenericSettingsHtml(data: ModuleManagerGenericSettingsControls) {
        const {
            metricSelectorHTML,
            attrSelectorHTML,
            dateRangeSelectorHTML,
            timeRangeSelectorHTML,
            intervalSelectorHTML,
            availableDateRanges,
            controlSettings,
        } = data;

        this.settingsManager.availableDateRanges = availableDateRanges.map(dr => ModuleManagerDateRangeInfo.fromObject(dr));

        // read selected metrics from metric selector html
        this.settingsManager.selectedMetrics = [];
        if (metricSelectorHTML) {
            this.hasMetricSelector = true;
            this.settingsManager.selectedMetrics = controlSettings.selectedMetrics;
            const abbreviations = this.settingsManager.selectedMetrics.map(m => m.CustomName && m.CustomName != "" ? m.CustomName : m.Abbreviation);
            this.settingsManager.selectedMetricsText = ClearViewUtils.joinWithMax(abbreviations, 40, ', ');
        }

        this.settingsManager.selectedLevelName = controlSettings.selectedGroupLevelName;
        this.setGenericSettingsControlSettings(controlSettings);

        //ng-hide false if selector is applicable to the module.
        if (dateRangeSelectorHTML != null) {
            this.hasDateSelector = true;
        }

        if (controlSettings.empSelectorDTO != null) {
            this.hasEmpSelector = true;
        }

        if (controlSettings.recSelectorDTO != null) {
            this.hasRecSelector = true;
        }

        if (attrSelectorHTML != null) {
            this.hasAttSelector = true;
        }

        if (intervalSelectorHTML != null) {
            this.hasIntervalSelector = true;
        }

        if (this.hasEmpSelector)
            this.settingsManager.selectedEmpCount = this.settingsManager.getSelectedCount(BaseGroupType.Employee);

        if (this.hasRecSelector)
            this.settingsManager.selectedRecCount = this.settingsManager.getSelectedCount(BaseGroupType.Recording);

        this.metricSelectorHtml = metricSelectorHTML;
        if (this.metricSelectorContainerEl && this.metricSelectorHtml)
            this.metricSelectorContainerEl.nativeElement.innerHTML = this.metricSelectorHtml;

        if (timeRangeSelectorHTML != null && timeRangeSelectorHTML !== "")
            this.$window.initSlider?.(this.$element); // function defined globally in TimeRangeSelector.js
    }

    setWallboardSettings() {
        if (this.pageName && this.includeDateSelector) {
            this.settingsManager.availableDateRanges = this.selectedSlideSettings.AvailableDateRanges;
            this.settingsManager.selectedDateRange = this.selectedSlideSettings.DateRange;
        }

        if (this.pageName && this.includeDaysOfWeek) {
            this.settingsManager.selectedDaysOfWeek = this.selectedSlideSettings.DaysOfWeek;
        }

        if (this.pageName && this.includeTimeSelector) {
            this.settingsManager.isTimeSelectorEnabled = this.selectedSlideSettings.TimeSelector?.TimeSelectorEnabled ?? false;
            this.settingsManager.invertTimeSelector = this.selectedSlideSettings.TimeSelector?.InvertTimeSelector ?? false;
            this.settingsManager.minTime = this.selectedSlideSettings.TimeSelector?.MinTime / 60;
            this.settingsManager.maxTime = this.selectedSlideSettings.TimeSelector?.MaxTime / 60;
        }
        if (this.pageName && this.includeEmpGroupSelector) {
            if (this.selectedSlideSettings?.EmpSelectorDTO) this.settingsManager.empSelectorDTO = this.selectedSlideSettings.EmpSelectorDTO;
            if (this.selectedSlideSettings?.SelectedToggle) this.settingsManager.selectedToggle = this.selectedSlideSettings.SelectedToggle;
        }
        if (this.pageName && this.includeRecGroupSelector) {
            this.settingsManager.recSelectorDTO = this.selectedSlideSettings.RecSelectorDTO;
        }
        if (this.pageName && this.includeMetricSelector) {
            this.settingsManager.selectedMetrics = this.selectedSlideSettings.SelectedMetrics ?? [];
            this.settingsManager.updateSelectedMetricsText();
        }

        if (this.pageName && this.includeSettingSlideDuration) {
            this.settingsManager.generalWallboardSettings = this.selectedSlideSettings.GeneralWallboardSettings;
            this.prevSlideName = this.settingsManager.generalWallboardSettings?.SlideName || '';
        }
        if(this.pageName && this.includeSettingColumnSort){
            this.settingsManager.wallboardColumnSortSettings = this.selectedSlideSettings.ColumnSortSettings;
        }
    }

    onDataCategoryViewChanged(inCatView: boolean) {
        this.inDataCatView = inCatView;
    }

    onUserCategoryViewChanged(inCatView: boolean) {
        this.inUserCatView = inCatView;
    }

    reloadMetrics() {
        // defined in MetricSelector.js
        this.$window.MetricSelectorRefresh(`${this.stateKey}_temp`);
    }

    async removeMetric(metricId: number) {
        const temp = this.isWallboard ? "" : "_temp"; //wallboards doesn't use _temp state
        let url = `/api/v1/metric-selector/${this.stateKey}${temp}/${metricId}`;
        if (this.isWallboard)
            url += `?creatorId=${this.wallboardCreatorId}`;
        const removeResponse = await this.cvApiService.delete<boolean>(url);
        if (removeResponse.data === true) {
            // update selected metrics text
            this.settingsManager.selectedMetrics = this.settingsManager.selectedMetrics.filter(m => m.Id !== metricId);
            this.settingsManager.updateSelectedMetricsText();

            const $metricSelectorModule = this.$element.find(".metricSelectorModule");
            $metricSelectorModule.attr("pagename", `${this.stateKey}${temp}`);
            // remove from metric selector (using jQuery because metric selector is jQuery)
            const $removeMetricButton = this.$element.find(`.selectedMetric[mid=${metricId}] .removeMetric`);
            $removeMetricButton.click();

            const selectedMetrics = this.settingsManager.selectedMetrics.filter((sm) => sm.Id !== metricId);

            const eventObj = {
                pageName: `${this.stateKey}${temp}`,
                selectedMetrics: new Array<number>(),
                metricNames: {},
                metricFullNames: {},
                mCT: {},
                result: false
            };

            selectedMetrics.forEach((sm) => {
                eventObj.selectedMetrics.push(sm.Id);
                eventObj.metricNames[sm.Id] = sm.Abbreviation;
                eventObj.metricFullNames[sm.Id] = sm.Name;
                eventObj.mCT[sm.Id] = sm.ConversionType;
            });

            $(document).trigger(new jQuery.Event("event_SelectedMetricsChanged", eventObj));
        }
    }

    applySettings() {
        // If date selection is greater then the maximum, do not apply settings and show error message
        if (this.settingsManager?.selectedDateRange) {
            const numDays = this.settingsManager.selectedDateRange.numberOfDays;
            if (numDays > this.moduleManager?.maxDateRange) {
                this.$window.showErrorDialog(this.cvLocalizationService.Format(
                    this.cvLocalizationService.getCachedText('Module', 'MaxDateRange',
                        `Date range larger than the maximum date range of {0} days.`),
                    this.moduleManager.maxDateRange
                )
                );
                return;
            }
        }

        if (this.isWallboard && !this.settingsManager?.generalWallboardSettings?.SlideName) {
            this.$window.showErrorDialog(
                this.cvLocalizationService.getCachedText('Wallboard_Management_Messages', 'Error_Name_Required',"Please enter a name."),
                this.cvLocalizationService.getCachedText('Wallboard_Management_Messages', 'Error_Name_Required_Title',"Name is Required")
            );
            return;
        }
        this.updateSlideTitle();

        // allow settings to request waits
        this.settingsManager.waitBeforeApplying = [];
        this.settingsManager.beforeSettingsApplied.next();

        const waitBeforeSaving: Promise<any>[] = [...this.settingsManager.waitBeforeApplying];
        let waitPromise: Promise<any> = null;
        if (waitBeforeSaving.length > 0)
            waitPromise = Promise.all(waitBeforeSaving);

        this.settingsManager.showInitialLevelName = true
        if (this.settingsManager.selectedLevelName) this.initializedLevelName = this.settingsManager.selectedLevelName

        this.settingsApplied.emit({
            waitBeforeSaving: waitPromise,
            settingsManager: this.settingsManager,
            fromModal: true,
        });
    }

    updateSlideTitle() {
        this.changeSlideoutTitle.emit({
            ShowTitle: this.settingsManager.generalWallboardSettings?.ShowTitle,
            title: this.settingsManager.generalWallboardSettings?.SlideName || '',
        });
    }

    cancelSettings(): void {
        this.settingsCancelled.emit();
        this.settingsManager.showInitialLevelName = true

        if (this.settingsManager.selectedLevelName)
            this.initializedLevelName = this.settingsManager.selectedLevelName

        this.settingsManager.onSettingsCancelled.next();
    }

    openMetricSelector() {
        const curSelectedMetrics = this.settingsManager.selectedMetrics;
        const newSelectedMetrics = [];

        if (!this.isWallboard) {
            const metricSelector = this.metricSelectorService.openModal(MetricSelectorComponent, this.moduleManager, curSelectedMetrics, true);
            metricSelector.result.then((metricSelectorResult) => {
                if (metricSelectorResult?.renameOnly) {
                    this.settingsManager.selectedMetrics.forEach((metric) => {
                        const matchMetric = metricSelectorResult?.renamedMetrics.find(m => m.MetricID == metric.Id);
                        if (matchMetric)
                            metric.CustomName = matchMetric.MetricCustomName;
                    })
                    this.settingsManager.updateSelectedMetricsText();
                }
                else if (metricSelectorResult) {
                    metricSelectorResult?.forEach(m => {
                        newSelectedMetrics.push({
                            Id: m.MetricID,
                            Abbreviation: m.Abbreviation,
                            Name: m.MetricName,
                            ConversionType: m.ConversionType,
                            CustomName: m.MetricCustomName
                        });
                    });
                    this.settingsManager.selectedMetrics = newSelectedMetrics;
                    this.settingsManager.updateSelectedMetricsText();
                }
            });
        }
        else {
            const metricSelector = this.metricSelectorService.openModalForWallboard(MetricSelectorComponent, this.pageName, this.wallboardId, curSelectedMetrics, this.wallboardCreatorId, true);
            metricSelector.result.then((metricSelectorResult) => {
                if (metricSelectorResult?.renameOnly) {
                    this.settingsManager.selectedMetrics.forEach((metric) => {
                        const matchMetric = metricSelectorResult?.renamedMetrics.find(m => m.MetricID == metric.Id);
                        if (matchMetric)
                            metric.CustomName = matchMetric.MetricCustomName;
                    })
                    this.settingsManager.updateSelectedMetricsText();
                }
                else if (metricSelectorResult) {
                    metricSelectorResult?.forEach(m => {
                        newSelectedMetrics.push({
                            Id: m.MetricID,
                            Abbreviation: m.Abbreviation,
                            Name: m.MetricName,
                            ConversionType: m.ConversionType,
                            CustomName: m.MetricCustomName
                        });
                    });
                    this.settingsManager.selectedMetrics = newSelectedMetrics;
                    this.settingsManager.updateSelectedMetricsText();
                }
            })
        }
    }

    public getMetricDisplayName(metric)
    {
        if(metric.CustomName && metric.CustomName != "")
            return metric.CustomName +"*";

        return metric.Abbreviation;
    }

    public getIsMetricRenamed(metric)
    {
        return metric.CustomName && metric.CustomName != "";
    }

    get isCurrentAgentState() {
        return this.SettingsModuleType === ModuleType.CurrentAgentStates || this.SettingsModuleType === ModuleType.ResponsiveCurrentAgentStates;
    }

    private getGroupsByLevel = () => {
        const gt = [...this.settingsManager?.empGroupTypes];
        const levels = gt?.sort((l1, l2) => l1.level - l2.level) || [];
        const selectedEmp: { level: number, name: string, empCount: number }[] = levels.flatMap(l => {
            if (this.settingsManager?.empSelectorDTO && this.settingsManager.empSelectorDTO[`_SelectedGroup${l.level}IDList`]) {
                const emp: number[] = this.settingsManager.empSelectorDTO[`_SelectedGroup${l.level}IDList`];
                if (emp.length === 0 || (emp.length === 1 && emp[0] === 0)) {
                    // all selected
                    return {
                        level: l.level,
                        name: l.name,
                        empCount: 0,
                    };
                }
                return {
                    level: l.level,
                    name: l.name,
                    empCount: emp.length,
                };
            }
            return [];
        });
        return selectedEmp.find(l => l.empCount > 0) || selectedEmp[0];
    };

    get empFilterLevelName() {
        const groupByLevel = this.getGroupsByLevel();
        return groupByLevel?.name || '';
    }

    cancelEditName() {
        if (this.settingsManager.generalWallboardSettings?.SlideName !== null || this.settingsManager.generalWallboardSettings?.SlideName !== undefined) {
            this.settingsManager.generalWallboardSettings.SlideName = this.prevSlideName;
            this.updateSlideTitle();
        }
        this.isEditingName = false;
    }

    updateCurrentName() {
        if (this.settingsManager.generalWallboardSettings?.SlideName !== null || this.settingsManager.generalWallboardSettings?.SlideName !== undefined) {
            this.prevSlideName = this.settingsManager.generalWallboardSettings.SlideName;
        }
        this.isEditingName = !this.isEditingName;
    }

    public getGroupCount(){
        let value = this.allText;
        if(this.options.includeViewBy || this.options.enableMultiGroupSelect)
        {
            if(this.settingsManager.selectedEmpCount !== 0)
                value = this.settingsManager.selectedEmpCount?.toString();
        }
        else // if single-select without group by, clamp to 1
            value = this.settingsManager.selectedEmpCount <= 1 ? this.settingsManager.selectedEmpCount?.toString() : '1';

        if (this.SettingsModuleType === ModuleType.CurrentAgentStates || this.SettingsModuleType === ModuleType.ResponsiveCurrentAgentStates) {
            if (this.getGroupsByLevel()?.empCount)
                value = (this.getGroupsByLevel()?.empCount).toString();
            else value = this.cvLocalizationService.getCachedText('Common', 'All', 'All');
        }

        return `(${value})`;
    }

    private onSelectedMetricsChangedHandler = (e: any) => this.onSelectedMetricsChanged(e);

    public onGeneralWallboardDetailChange() {
        this.updateSlideTitle();
        this.onWallboardGeneralSettingChanged.emit(this.settingsManager.generalWallboardSettings);
    }
}
